import { ControlStatus } from '@/gen/controls/v1/control_status_pb'

/**
 * Controls a reviewer still has to act on — the "unvalidated" counts, badges and issue lists.
 * Attested included: a vendor's claim is not evidence. Scoring deliberately disagrees and
 * counts it as validated — see isResolvedControlStatus.
 * Not-applicable is deliberately excluded: it is a resolved decision, not an open issue.
 * Not-evaluated is excluded too, since it has no verdict yet.
 */
export const isUnvalidatedControlStatus = (status: ControlStatus | undefined): boolean =>
  status === ControlStatus.GAP ||
  status === ControlStatus.NO_EVIDENCE ||
  status === ControlStatus.ATTESTED

/**
 * Controls that no longer hold up an assessment. Not-applicable counts as done: it was reviewed
 * and deliberately taken out of scope, so it must not block concluding the assessment.
 */
export const isResolvedControlStatus = (
  status: ControlStatus | undefined,
): status is ControlStatus.VALIDATED | ControlStatus.NOT_APPLICABLE =>
  status === ControlStatus.VALIDATED || status === ControlStatus.NOT_APPLICABLE

/**
 * Attested is deliberately in both this and isUnvalidatedControlStatus (guidelines 12
 * and 15 against 8): scoring is closed, the reviewer's list is not.
 */
export const scoresAsValidatedControlStatus = (status: ControlStatus | undefined): boolean =>
  status === ControlStatus.VALIDATED || status === ControlStatus.ATTESTED

/** Statuses a reviewer may set by hand, in menu order. Not-evaluated is AI-only, so it isn't here. */
export const SELECTABLE_CONTROL_STATUSES = [
  ControlStatus.GAP,
  ControlStatus.VALIDATED,
  ControlStatus.ATTESTED,
  ControlStatus.NO_EVIDENCE,
  ControlStatus.NOT_APPLICABLE,
] as const
